import { TextValue } from '@shared/types';

export enum DiscountTypesEnum {
    NONE = 0,
    BETA_USER = 1,
    CREDIT,
    FREE_CONTROLS,
    FREE_TRIAL,
    PROMOTION,
}

export const discountTypeText: { [key in DiscountTypesEnum]: string } = {
    [DiscountTypesEnum.NONE]: '',
    [DiscountTypesEnum.BETA_USER]: 'Beta User',
    [DiscountTypesEnum.CREDIT]: 'Credit',
    [DiscountTypesEnum.FREE_CONTROLS]: 'Free Controls',
    [DiscountTypesEnum.FREE_TRIAL]: 'Free Trial',
    [DiscountTypesEnum.PROMOTION]: 'Promotion',
};

export const ckmDiscountTypes: TextValue[] = [
    { text: discountTypeText[DiscountTypesEnum.BETA_USER], value: DiscountTypesEnum.BETA_USER },
    { text: discountTypeText[DiscountTypesEnum.CREDIT], value: DiscountTypesEnum.CREDIT },
    { text: discountTypeText[DiscountTypesEnum.FREE_TRIAL], value: DiscountTypesEnum.FREE_TRIAL },
    { text: discountTypeText[DiscountTypesEnum.PROMOTION], value: DiscountTypesEnum.PROMOTION },
];

export const userDiscountTypes: TextValue[] = [
    { text: discountTypeText[DiscountTypesEnum.NONE], value: DiscountTypesEnum.NONE },
    { text: discountTypeText[DiscountTypesEnum.BETA_USER], value: DiscountTypesEnum.BETA_USER },
    { text: discountTypeText[DiscountTypesEnum.CREDIT], value: DiscountTypesEnum.CREDIT },
    { text: discountTypeText[DiscountTypesEnum.FREE_CONTROLS], value: DiscountTypesEnum.FREE_CONTROLS },
    { text: discountTypeText[DiscountTypesEnum.FREE_TRIAL], value: DiscountTypesEnum.FREE_TRIAL },
    { text: discountTypeText[DiscountTypesEnum.PROMOTION], value: DiscountTypesEnum.PROMOTION },
];
